export const environment = {
  production: false,
  mail: 'djothi974@gmail.com'
};

export const firebaseConfig = {
  apiKey: "AIzaSyCdpzRxLHv5rv_LcrayrMhy0AGpfMnRaqk",
  authDomain: "nutriner-1795c.firebaseapp.com",
  databaseURL: "https://nutriner-1795c.firebaseio.com",
  projectId: "nutriner-1795c",
  storageBucket: "nutriner-1795c.appspot.com",
  messagingSenderId: "732167581660",
  appId: "1:732167581660:web:b37a06a1727f3da1d06919",
  measurementId: "G-VR013RHPXG"
};